import { useState, useEffect } from "react";

interface ForbiddenError {
  message: string;
  status: number;
}

export const useForbiddenError = () => {
  const [error, setError] = useState<ForbiddenError | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleForbiddenError = (event: CustomEvent<ForbiddenError>) => {
      setError(event.detail);
      setIsOpen(true);
    };

    // Listen for custom 403 error events
    window.addEventListener(
      "api-403-error",
      handleForbiddenError as EventListener
    );

    return () => {
      window.removeEventListener(
        "api-403-error",
        handleForbiddenError as EventListener
      );
    };
  }, []);

  const closeError = () => {
    setIsOpen(false);
    setError(null);
  };

  return {
    error,
    isOpen,
    closeError,
  };
};
